/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import { State } from 'redux/initialState';
import { getUserSocieties } from 'modules/society/redux/societyActions';
import {
  AdministratedListData,
  AdministratedListResponse,
} from 'modules/society/types/AdministratedList';
import { mapAdministratedDataToTable } from '../utils/mapAdministratedDataToTable';

interface UseAdministratedListProps {
  data: AdministratedListData;
  isLoading: boolean;
  isError: boolean;
}

export const useAdministratedList = (): UseAdministratedListProps => {
  const { i18n } = useTranslate();
  const user = useSelector((state: State) => state.user);
  const isDemo = useSelector((state: State) => state.society?.role?.isDemo);

  const [data, setData] = useState<AdministratedListData>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const [administratedData, setAdministratedData] =
    useState<AdministratedListResponse>([]);

  useEffect(() => {
    const fetchAdministratedSocieties = async () => {
      if (!user?.societies?.administrated?.length) {
        return;
      }

      try {
        setIsLoading(true);
        setIsError(false);

        const response = (await getUserSocieties(
          user['_id'],
          'admin',
          null,
          'table'
        )) as AdministratedListResponse;

        setAdministratedData(response);
      } catch (error) {
        setIsError(true);
        setAdministratedData([]);
        setData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAdministratedSocieties();
  }, [user]);

  useEffect(() => {
    if (!administratedData || !Array.isArray(administratedData)) {
      setData([]);
      return;
    }

    const transformedData = mapAdministratedDataToTable({
      data: administratedData,
      user,
      i18n,
      isDemo,
    });

    setData(transformedData);
  }, [administratedData, i18n, i18n.language, isDemo, user]);

  return {
    data,
    isLoading,
    isError,
  };
};
